import { AxiosInstance } from 'axios'
import AxiosContext from '../context/AxiosContext'
import { useContext } from 'react'

export default function useAxios(): AxiosInstance {
    return useContext(AxiosContext)
}
